<template>
  <div>
    <slot v-if="$slots.title" name="title"></slot>
    <h3 v-else-if="title">{{ title }}</h3>
    <b-row class="mt-2">
      <b-col>
        <b-card title="ฝาก">
          <b-card-text>
            <div class="font-weight-semibold font-size-24 text-success">
              <template v-if="deposit > 0">+</template>{{ Number(deposit).toLocaleString() }} บาท
            </div>
            <div class="text-muted">{{ Number(depositCount).toLocaleString() }} รายการ</div>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col>
        <b-card title="ถอน">
          <b-card-text>
            <div class="font-weight-semibold font-size-24 text-danger">
              <template v-if="withdraw > 0">-</template>{{ Number(withdraw).toLocaleString() }} บาท
            </div>
            <div class="text-muted">{{ Number(depositCount).toLocaleString() }} รายการ</div>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col>
        <b-card title="ส่วนต่าง">
          <b-card-text>
            <div :class="difference > 0 ? 'text-success' : difference < 0 ? 'text-danger' : ''" class="font-weight-semibold font-size-24">
              <template v-if="difference > 0">+</template>{{ Number(difference).toLocaleString() }} บาท
            </div>
            <div>&nbsp;</div>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col>
        <b-card title="ยอดคงเหลือ">
          <b-card-text>
            <div class="font-weight-semibold font-size-24 text-info">{{ Number(balance).toLocaleString() }} บาท</div>
            <div class="text-muted">ณ ปัจจุบัน</div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'PaymentGatewayStatistic',
  props: {
    title: {
      type: String,
      default: null
    },
    deposit: {
      type: Number,
      required: true
    },
    withdraw: {
      type: Number,
      required: true
    },
    depositCount: {
      type: Number,
      required: true
    },
    withdrawCount: {
      type: Number,
      required: true
    },
    balance: {
      type: Number,
      required: true
    }
  },
  computed: {
    difference() {
      return Number(this.deposit) - Number(this.withdraw)
    }
  }
}
</script>